import { classNames } from '../../helpers/classNames';
import styles from './style.module.scss';

interface Props {
    width?: string;
    height?: string;
    marginTop?: string;
    marginBottom?: string;
    position?: string;
    variant?: 'primary' | 'secondary' | 'tertiary';
}

function Divider(props: Props) {
    const {
        variant = 'primary',
        width = '100%',
        height = '1px',
        marginTop = '0',
        marginBottom = '0',
    } = props;

    const styleDivider = {
        width: width,
        height: height,
        marginTop: marginTop,
        marginBottom: marginBottom,
    };

    return (
        <div
            style={styleDivider}
            className={classNames([styles[variant]])}
        ></div>
    );
}

export default Divider;
